export var UserAuthenticationType;
(function (UserAuthenticationType) {
    UserAuthenticationType[UserAuthenticationType["ActiveDirectory"] = 0] = "ActiveDirectory";
    UserAuthenticationType[UserAuthenticationType["Password"] = 1] = "Password";
    UserAuthenticationType[UserAuthenticationType["Facebook"] = 2] = "Facebook";
    UserAuthenticationType[UserAuthenticationType["SAML"] = 3] = "SAML";
    UserAuthenticationType[UserAuthenticationType["OpenID"] = 4] = "OpenID";
    UserAuthenticationType[UserAuthenticationType["RepositorySSO"] = 5] = "RepositorySSO";
})(UserAuthenticationType || (UserAuthenticationType = {}));
;
